/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { List, Record } from 'immutable'
import LocalDate from '../../domain/type/Date'

const _DailyClosingHeadState = {
  id: null,
  room_id: null,
  status: null,
  close_date: null,
  monthly_close_date_year: null,
  monthly_close_date_month: null,
  monthly_close_date: null,
  rsvn_sales: 0,
  ota_comsn: null,
  rsvn_pay_comsn: 0,
  sales: 0,
  variable_costs: 0,
  fixed_costs: 0,
  variable_expenses: 0,
  fixed_expenses: 0,
  accom_pay_comsn: 0,
  accom_pay_code: '',
  memo: null,
  user_name: '',
  room_name: '',
  reservations: [],
  daily_closing_reservations: []
}

class DailyClosingHeadState extends Record(_DailyClosingHeadState) {
  mergeModel(model) {
    if (model.close_date) {
      const close_date = new LocalDate(model.close_date)
      const close_month = new LocalDate(model.monthly_close_date)

      model.close_date = close_date
      model.monthly_close_date = close_month
      model.monthly_close_date_year = close_month.year
      model.monthly_close_date_month = close_month.month
    }

    return this.merge(model)
  }

  addReservation(reservation) {
    if (!this.reservations) {
      return this
    }
    const hasItem = this.reservations.find(r => r.id == reservation.id)
    if (!hasItem) {
      this.reservations.push(reservation)
    }

    return this
  }

  setReservations(reservations) {
    return this.merge({ reservations: List(reservations) })
  }

  toRequestBody() {
    return {
      id: this.id,
      room_id: this.room_id,
      status: this.status,
      close_date: this.close_date.toJSDate(),
      monthly_close_date: this.monthly_close_date.toJSDate(),
      memo: this.memo
    }
  }
}

export { DailyClosingHeadState }
